export default __webpack_public_path__ + "5c7138f.png";